import React from "react";
import PropTypes from 'prop-types';

import ListPageHeader from "./components/list_page_header.js";
import TableView from "../../base/table/table_view.js";

import FormFields from "../../base/form/form_fields.js";

import { ClearItemValue } from "../../base/inputs/constants.js";

// TODO: Document it
class BaseListPage extends React.Component {

  constructor(props) {
    super(props);

    this.dataModel   = props.dataModel;
    this.listUseCase = props.listUseCase;

    this.scrollThreshold = 200;
    this.onScroll = this.onScroll.bind(this);

    this.onChangeFilterField = this.onChangeFilterField.bind(this);
    this.onChangeFilter      = this.onChangeFilter.bind(this);
    this.onChangeSort        = this.onChangeSort.bind(this);

    this.loadItems = this.loadItems.bind(this);
    this.processLoadedItems = this.processLoadedItems.bind(this);

    this.state = {
      items: [],
      filterData: {
        published: ClearItemValue
      },
      paginationInfo: BaseListPage.defaultPaginationInfo()
    }
  }

  componentDidMount() {
    this.loadItems();
  }

  static getDerivedStateFromProps(props, state) {
    let { filterData: newFilters = {} } = props;
    let { filterData, paginationInfo, items } = state;

    if(JSON.stringify(filterData) !== JSON.stringify(newFilters)) {
      filterData = newFilters;
      paginationInfo = { ...BaseListPage.defaultPaginationInfo() };
      items = [];
    }
    return {...state,
      filterData: { ...filterData },
      paginationInfo: { ...paginationInfo },
      items: items
    };
  }

  static defaultPaginationInfo() {
    return {
      page: 1,
      perPage: 50
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.isNewFilter(this.state, nextState) ||
           this.isNextPage(this.state, nextState) ||
           JSON.stringify(this.state.items) !== JSON.stringify(nextState.items) ||
           this.state.loading               !== nextState.loading; 
  }

  componentDidUpdate(prevProps, prevState) {
    // Check if need launch loading items
    if(this.isNewFilter(prevState, this.state) || 
       this.isNextPage(prevState, this.state)) {
      this.loadItems();
    }
    
    // Check if need load until fills page
    const { items: prevItems } = prevState;
    const { items: currItems, loading, paginationInfo } = this.state;
    let containerHeight = this.scrollContainer.clientHeight;
    let contentHeight = this.scrollContent.clientHeight;

    if(containerHeight > contentHeight &&
       !loading &&
       paginationInfo.hasMore &&
       prevItems.length < currItems.length) {
      this.setState({
        loading: true,
        paginationInfo: {
          ...paginationInfo,
          page: paginationInfo.page + 1
        }
      })
    }
  }

  isNewFilter(prevState, nextState) {
    const { filterData: prevFilters } = prevState;
    const { filterData: nextFilters } = nextState;
    return JSON.stringify(prevFilters) !== JSON.stringify(nextFilters);
  }

  isNextPage(prevState, nextState) {
    const { paginationInfo: prevPaginationInfo } = prevState;
    const { paginationInfo: nextPaginationInfo } = nextState;
    return prevPaginationInfo.page < nextPaginationInfo.page;
  }

  loadItems() {
    if(!this.listUseCase) {
      return;
    }
    const { filterData, paginationInfo } = this.state;
    this.setState({
      loading: true
    });

    if(this.listUseCase.cancel) {
      this.listUseCase.cancel();
    }

    this.listUseCase.execute({...filterData, ...paginationInfo})
    .then((result) => {
      const { items } = this.state;
      const { data: { list, paginationInfo } } = result; 
      let newItems = items.concat(this.processLoadedItems(list));
      
      this.setState({
        loading: false,
        items: newItems,
        paginationInfo: paginationInfo
      });
    })
    .catch((result) => {
      if(paginationInfo.page > 1) {
        paginationInfo.page -= 1;
      }
      this.setState({
        loading: false,
        paginationInfo: paginationInfo
      });
      this.props.showServerErrorIfNeed(result);
    })

  }

  processLoadedItems(items) {
    return items;
  }

  onChangeFilterField(newItem, field, newValue) {
    let value = newValue;
    let fieldName = field.name;
    if(field.type === "enum" && value === ClearItemValue) {
      value = undefined;
    }
    if(field.type === "model") {
      fieldName = field.foreignKey;
      value = newItem[fieldName];
      
    }
    this.onChangeFilter(fieldName, value);
  }

  onChangeFilter(name, value) {
    const { changeLocationSearch } = this.props;
    changeLocationSearch({
      [name]: value
    });
  }

  onChangeSort(orderColumn, orderType) {
    const { changeLocationSearch } = this.props;
    changeLocationSearch({
      orderColumn: orderColumn,
      orderType: orderType
    });
  }

  onScroll() {
    const { paginationInfo, loading } = this.state;
    if(!paginationInfo.hasMore || loading) {
      return;
    }

    let contentHeight = this.scrollContent.clientHeight;
    let scrollPosition = this.scrollContainer.scrollTop + this.scrollContainer.clientHeight;
    
    if(scrollPosition >= contentHeight - this.scrollThreshold) {
      this.setState({
        loading: true,
        paginationInfo: {
          ...paginationInfo,
          page: paginationInfo.page + 1
        }
      })
    }
  }

  header() {
    return <ListPageHeader onChangeFilter = { this.onChangeFilter } >
      { this.headerContent() }
    </ListPageHeader>
  }

  headerContent() {
    return <React.Fragment />
  }

  filters() {
    const { filterData } = this.state;
    let filterFields = this.dataModel.listFilters();
    return <FormFields formFields = { filterFields } 
                       item = { filterData }
                       onItemChange = { this.onChangeFilterField } 
                       defaultWeight = { 2 } />
  }

  content() {
    const { items, filterData } = this.state;
    return <TableView columns = { this.dataModel.listFields() }
                      filterData = { filterData }
                      items = { items }
                      onChangeSort = { this.onChangeSort } />
  }
  
  render() {
    const { classes } = this.props;

    return <div className = { classes.page }
                onScroll = { this.onScroll }
                ref = { (ref) => this.scrollContainer = ref } >
      <div className = { classes.pageHeader } >
        { this.header() }
      </div>
      <div className = { classes.pageFilters } >
        { this.filters() }
      </div>
      <div className = { classes.pageContent }
           ref = { (ref) => this.scrollContent = ref } >
        <div className = { classes.pageList } >
          { this.content() }
        </div>
      </div>
    </div>
  }
  
}

BaseListPage.propTypes = {
  dataModel: PropTypes.object,
  listUseCase: PropTypes.object,
}

BaseListPage.defaultProps = {
}

export default BaseListPage;